import styled from "styled-components";

export const CardContainer = styled.div`
  margin-top: 1rem;
`;

export const HeaderContainer = styled.div`
  padding: 1.5rem;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainDropZoneWrapper = styled.div<{ hasActiveFile: boolean }>`
  align-items: center;
`;

export const MigrationDropZoneContainer = styled.div`
  .Polaris-DropZone-FileUpload {
    padding: 0;
  }
`;

export const OpenDromoContainer = styled.div`
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const UploadFileSpan = styled.span`
  margin-top: 12px;
  color: #999;
`;

export const TableScrollContainer = styled.div`
  position: relative;
  overflow-x: auto;

  th:last-child,
  td:last-child {
    position: sticky;
    right: 0;
    z-index: 2;
    min-width: 140px;
    border-left: 1px solid #e5e7eb;
  }

  td:last-child {
    background: #fff;
  }
`;
